import {observer} from 'mobx-react';
import TimeOffRequestDetailsState from '../state/TimeOffRequestDetailsState';
import {withState, t} from 'shared/core';
import {Layout, Panel, ActionLink, Accordion} from 'shared/components';
import {CustomHours, List} from 'main/components';
import RequestHistory from './RequestHistory';
import Usage from '../../pending_requests/components/Usage';
import Attachments from '../../pending_requests/components/Attachments';
import _ from 'lodash';

const TimeOffRequestDetails = observer(({uiState}) => {
  const {request, daysOff, summaryItems} = uiState;
  const type = request.timeOffType.name;

  return (
    <div>
      <Layout>
        <Layout.Section>
          <Panel.Stack loose>
            <Panel>
              <Panel.Header
                title={t('time_off.requests.TYPE_REQUEST', {type})}
              />
              <Panel.Subheader title={request.datesView} />
              <List items={summaryItems} />
              <Panel.Separator className='mt3' />
              <Panel.Subheader title={t('time_off.requests.Days Off')} />
              <CustomHours models={daysOff.slice(0, TimeOffRequestDetailsState.MAX_DAYS_OFF_ITEMS)} />
              <div className='mb2'>
                <Accordion active={uiState.expanded}>
                  <div className='mt1'>
                    <CustomHours models={daysOff.slice(TimeOffRequestDetailsState.MAX_DAYS_OFF_ITEMS)} />
                  </div>
                </Accordion>
              </div>
              {daysOff.length > TimeOffRequestDetailsState.MAX_DAYS_OFF_ITEMS && <ActionLink
                onClick={() => uiState.expanded = !uiState.expanded}
                className='h6 waterloo'>
                {uiState.expandedText}
              </ActionLink>}
              {!_.isEmpty(request.attachments) && <>
                <Panel.Separator className='mt3'/>
                <Attachments attachments={request.attachments}/>
              </>}
            </Panel>
            <RequestHistory uiState={uiState} />
          </Panel.Stack>
        </Layout.Section>
        <Layout.Section secondary>
          <Usage uiState={uiState} />
        </Layout.Section>
      </Layout>
    </div>
  )
});

export default withState(TimeOffRequestDetails, TimeOffRequestDetailsState);
